/* =============================================================================
   pl-v2.js — segunda ronda: interacciones (anime.js) + escenas de scroll (GSAP)
   Un elemento lo anima UN solo motor.
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};
  var A = function () { return window.anime; };
  var touch = window.matchMedia('(hover: none)').matches;

  /* ===================================== hero: mini reseñas tipo historias */
  function initStories(root) {
    root.querySelectorAll('[data-rv2]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var items = box.querySelectorAll('.rv2__item'), bars = box.querySelectorAll('.rv2__bars i');
      var secs = Number(box.getAttribute('data-rv2')) || 5, i = 0, t0 = 0, raf = null, paused = false, visible = false;
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
      function show(n) {
        items[i].classList.remove('is-on');
        i = (n + items.length) % items.length;
        bars.forEach(function (b, k) { b.classList.toggle('is-done', k < i); b.querySelector('b').style.width = k < i ? '100%' : '0'; });
        var it = items[i]; it.classList.add('is-on');
        if (A()) {
          A().animate(it.querySelector('.rv2__q'), { opacity: [0, 1], y: [10, 0], filter: ['blur(6px)', 'blur(0px)'], duration: 650, ease: 'outQuad' });
          A().animate(it.querySelector('.rv2__who'), { opacity: [0, 1], x: [-10, 0], duration: 600, delay: 150, ease: 'outQuad' });
        }
        t0 = performance.now();
      }
      function tick(now) {
        if (!paused && visible) {
          var p = Math.min(1, (now - t0) / (secs * 1000));
          var b = bars[i] && bars[i].querySelector('b'); if (b) b.style.width = (p * 100).toFixed(1) + '%';
          if (p >= 1) show(i + 1);
        } else t0 = now - (parseFloat((bars[i] && bars[i].querySelector('b').style.width) || 0) / 100) * secs * 1000;
        raf = requestAnimationFrame(tick);
      }
      box.querySelector('.rv2__tap--l').addEventListener('click', function () { show(i - 1); });
      box.querySelector('.rv2__tap--r').addEventListener('click', function () { show(i + 1); });
      box.addEventListener('pointerdown', function () { paused = true; });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (e) { box.addEventListener(e, function () { paused = false; }); });
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(box);
      items[0].classList.add('is-on'); t0 = performance.now(); raf = requestAnimationFrame(tick);
    });
  }

  /* ======================================================= acordeones nuevos */
  function initAcc(root) {
    root.querySelectorAll('.ac2').forEach(function (it) {
      if (it._ok) return; it._ok = true;
      var q = it.querySelector('.ac2__q'), a = it.querySelector('.ac2__a'), inner = it.querySelector('.ac2__in');
      if (it.classList.contains('is-open')) a.style.height = 'auto';
      q.addEventListener('click', function () {
        var open = !it.classList.contains('is-open');
        it.classList.toggle('is-open', open); q.setAttribute('aria-expanded', open);
        var h = inner.offsetHeight;
        if (!A()) { a.style.height = open ? 'auto' : '0px'; return; }
        A().animate(a, { height: open ? [0, h] : [h, 0], duration: open ? 560 : 380, ease: open ? 'outExpo' : 'inOutQuad',
          onComplete: function () { if (open) a.style.height = 'auto'; } });
        if (open) A().animate(inner.children.length ? inner.children : inner, { opacity: [0, 1], y: [-6, 0], duration: 480, delay: A().stagger(50, { start: 80 }), ease: 'outQuad' });
      });
    });
  }

  /* ============================================ activos: voltear al tocar */
  function initFlip(root) {
    root.querySelectorAll('.pfl__card').forEach(function (c) {
      if (c._ok) return; c._ok = true;
      c.addEventListener('click', function () { c.classList.toggle('is-flip'); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('is-flip'); } });
      new IntersectionObserver(function (en, ob) {
        if (en[0].isIntersecting) { ob.disconnect(); setTimeout(function () { c.classList.add('is-shine'); }, 500 + Number(c.getAttribute('data-i') || 0) * 180); }
      }, { threshold: 0.6 }).observe(c);
    });
  }

  /* ============================================= reseñas: carrusel 3D */
  function initCoverflow(root) {
    root.querySelectorAll('[data-pcf]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var row = box.querySelector('.pcf__row'), cards = Array.prototype.slice.call(row.querySelectorAll('.plr__card'));
      var raf = null;
      function paint() {
        raf = null;
        var mid = row.getBoundingClientRect().left + row.clientWidth / 2;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect(), d = ((r.left + r.width / 2) - mid) / r.width;   // -1 izq · 0 centro · 1 der
          var ad = Math.min(Math.abs(d), 2);
          c.style.transform = 'rotateY(' + (-d * 28).toFixed(1) + 'deg) scale(' + (1 - ad * 0.14).toFixed(3) + ') translateZ(' + (-ad * 60).toFixed(0) + 'px)';
          c.style.opacity = (1 - ad * 0.35).toFixed(2);
          c.style.zIndex = String(100 - Math.round(ad * 10));
        });
      }
      row.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      window.addEventListener('resize', paint);
      var step = function () { return cards[0] ? cards[0].offsetWidth : 300; };
      var p = box.querySelector('[data-prev]'), n = box.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { stop(); row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { stop(); row.scrollBy({ left: step(), behavior: 'smooth' }); });
      // empieza en la segunda para que se vea el 3D a los dos lados
      requestAnimationFrame(function () { if (cards[1]) row.scrollLeft = cards[1].offsetLeft - (row.clientWidth - cards[1].offsetWidth) / 2; paint(); });
      var auto = setInterval(function () {
        if (!document.hidden) {
          var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
          row.scrollTo({ left: atEnd ? 0 : row.scrollLeft + step(), behavior: 'smooth' });
        }
      }, 4200);
      function stop() { clearInterval(auto); }
      ['pointerdown', 'touchstart'].forEach(function (e) { row.addEventListener(e, stop, { passive: true }); });
    });
  }

  /* ================================== comparativa: marcador que se llena */
  function initScore(root) {
    root.querySelectorAll('[data-plc-score]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      new IntersectionObserver(function (en, ob) {
        if (!en[0].isIntersecting) return; ob.disconnect();
        box.querySelectorAll('.plc__sc').forEach(function (sc) {
          var n = Number(sc.getAttribute('data-n')), tot = Number(sc.getAttribute('data-t')) || 1;
          var b = sc.querySelector('b'), bar = sc.querySelector('.plc__bar i'), o = { v: 0 };
          if (!A()) { b.textContent = n + '/' + tot; bar.style.width = (n / tot * 100) + '%'; return; }
          A().animate(o, { v: n, duration: 1400, ease: 'outQuart', onUpdate: function () { b.textContent = Math.round(o.v) + '/' + tot; } });
          A().animate(bar, { width: ['0%', (n / tot * 100) + '%'], duration: 1400, ease: 'outQuart' });
        });
      }, { threshold: 0.5 }).observe(box);
    });
  }

  function init(root) { root = root || document; initStories(root); initAcc(root); initFlip(root); initCoverflow(root); initScore(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ================================================== ESCENAS (GSAP) */

  // Manifiesto: cada palabra se levanta en 3D, sale del desenfoque y las palabras
  // clave se subrayan; el símbolo "ee" gira despacio detrás.
  ONX.scenes['pl-manifiesto'] = function (el, gsap) {
    var w = el.querySelectorAll('.plm__w'), u = el.querySelectorAll('.plm__u'), bg = el.querySelector('.plm__bg');
    gsap.set(w, { opacity: 0.1, yPercent: 35, rotateX: -55, filter: 'blur(5px)' });
    var tl = gsap.timeline({ scrollTrigger: { trigger: el, start: 'top 78%', end: 'bottom 50%', scrub: 0.6 } });
    tl.to(w, { opacity: 1, yPercent: 0, rotateX: 0, filter: 'blur(0px)', stagger: 0.08, ease: 'power2.out', duration: 0.6 }, 0);
    if (u.length) tl.to(u, { scaleX: 1, stagger: 0.25, ease: 'power2.inOut', duration: 0.5 }, 0.4);
    if (bg) gsap.fromTo(bg, { rotate: -25, scale: 0.85 }, { rotate: 35, scale: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 1 } });
  };

  // Frases editoriales: dos filas que se deslizan en sentidos opuestos con el scroll
  ONX.scenes['pl-frases'] = function (el, gsap) {
    el.querySelectorAll('.pled__row').forEach(function (r, i) {
      var dir = i % 2 ? 1 : -1;
      gsap.fromTo(r, { xPercent: dir < 0 ? 0 : -28 }, { xPercent: dir < 0 ? -28 : 0, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 0.5 } });
    });
  };

  // Tarjetas que se apilan: la de abajo se encoge y oscurece cuando la siguiente la cubre
  ONX.scenes['pl-apila'] = function (el, gsap) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('.pst__card'));
    cards.forEach(function (c, i) {
      var next = cards[i + 1];
      if (!next) return;
      gsap.to(c, { scale: 0.9 + i * 0.015, filter: 'brightness(.88)', ease: 'none',
        scrollTrigger: { trigger: next, start: 'top bottom', end: 'top ' + (90 + (i + 1) * 12) + 'px', scrub: 0.4 } });
    });
    cards.forEach(function (c) {
      var img = c.querySelector('.pst__img img');
      if (img) gsap.fromTo(img, { scale: 1.18 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: c, start: 'top bottom', end: 'top 30%', scrub: 0.6 } });
    });
  };

  // Activos: entran en 3D (caen desde atrás, inclinadas) escalonadas
  ONX.scenes['pl-flip'] = function (el, gsap, ST, env) {
    var cards = el.querySelectorAll('.pfl__card');
    gsap.fromTo(cards, { rotateX: 55, rotateY: env.mobile ? 0 : -18, y: 120, z: -220, opacity: 0 },
      { rotateX: 0, rotateY: 0, y: 0, z: 0, opacity: 1, stagger: 0.18, ease: 'power3.out',
        scrollTrigger: { trigger: el.querySelector('.pfl__grid'), start: 'top 85%', end: 'top 30%', scrub: 0.8 } });
    el.querySelectorAll('.pfl__img').forEach(function (img) {
      gsap.fromTo(img, { y: 22, rotate: -6 }, { y: -22, rotate: 6, ease: 'none', scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
    });
  };

  // Cómo usar: los pasos orbitan en un anillo 3D que gira con el scroll (como un planeta)
  ONX.scenes['pl-orbita'] = function (el, gsap, ST, env) {
    var ring = el.querySelector('.porb__ring'), cards = Array.prototype.slice.call(el.querySelectorAll('.porb__card'));
    var dots = el.querySelectorAll('.porb__dots i'), planet = el.querySelector('.porb__planet'), orbit = el.querySelector('.porb__orbit');
    var n = cards.length; if (!n) return;
    // separación corta: las tarjetas vecinas se asoman a los lados como un abanico curvo
    var step = Math.min(360 / n, env.mobile ? 44 : 40);
    var radius = function () { return ring.offsetWidth * (env.mobile ? 1.35 : 1.7); };
    function place() { var R = radius(); cards.forEach(function (c, i) { c.style.transform = 'rotateY(' + (i * step) + 'deg) translateZ(' + R + 'px)'; }); }
    place(); window.addEventListener('resize', place);
    var st = { a: 0 };
    function paint() {
      gsap.set(ring, { rotateY: -st.a, rotateX: -6, z: -radius() });
      var act = Math.round(st.a / step) % n;
      cards.forEach(function (c, i) {
        var diff = Math.abs(((i * step - st.a) % 360 + 540) % 360 - 180);   // 0 = de frente
        c.style.opacity = (1 - Math.min(diff / (step * 2.2), 1) * 0.7).toFixed(2);
        c.style.filter = diff > 20 ? 'saturate(.6)' : 'none';
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === act); });
    }
    paint();
    gsap.to(st, { a: step * (n - 1), ease: 'none', onUpdate: paint,
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.8, snap: { snapTo: 1 / (n - 1), duration: 0.5, delay: 0.1 } } });
    if (planet && orbit) gsap.to(orbit, { rotateZ: 360, ease: 'none', scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 1 } });
  };

  // Mecanismo: cada imagen se revela en círculo, el contador avanza y el anillo se llena
  ONX.scenes['pl-mecanismo'] = function (el, gsap) {
    var imgs = el.querySelectorAll('.pmx__img'), steps = el.querySelectorAll('.pmx__step'), prg = el.querySelector('.pmx__prg');
    var num = el.querySelector('.pmx__num'), n = steps.length; if (!n) return;
    var C = prg ? 2 * Math.PI * Number(prg.getAttribute('r')) : 0;
    if (prg) { prg.style.strokeDasharray = C; prg.style.strokeDashoffset = C * (1 - 1 / n); }
    gsap.set(steps, { autoAlpha: 0, y: 30 }); gsap.set(steps[0], { autoAlpha: 1, y: 0 });
    var tl = gsap.timeline({ defaults: { ease: 'power2.inOut' },
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.7,
        onUpdate: function (s) {
          var k = Math.min(n - 1, Math.floor(s.progress * n * 0.999));
          if (num) num.textContent = String(k + 1).padStart(2, '0');
          if (prg) prg.style.strokeDashoffset = (C * (1 - (s.progress * (n - 1) + 1) / n)).toFixed(1);
        } } });
    for (var i = 1; i < n; i++) {
      tl.to(imgs[i - 1], { scale: 1.12, filter: 'blur(3px)', duration: 0.6 }, i - 0.6)
        .fromTo(imgs[i], { clipPath: 'circle(0% at 50% 60%)' }, { clipPath: 'circle(100% at 50% 50%)', duration: 0.6 }, i - 0.6)
        .to(steps[i - 1], { autoAlpha: 0, y: -30, duration: 0.3 }, i - 0.6)
        .to(steps[i], { autoAlpha: 1, y: 0, duration: 0.35 }, i - 0.3);
    }
    tl.to({}, { duration: 0.5 });
  };

  // Comparativa: las filas entran una a una y los checks rebotan
  ONX.scenes['pl-compara'] = function (el, gsap) {
    var rows = el.querySelectorAll('.plc__row:not(.plc__head)');
    gsap.from(rows, { x: -40, opacity: 0, stagger: 0.12, ease: 'power3.out', duration: 0.7, scrollTrigger: { trigger: el.querySelector('.plc__table'), start: 'top 75%' } });
    gsap.from(el.querySelectorAll('.plc__ok'), { scale: 0, rotate: -90, stagger: 0.12, delay: 0.3, ease: 'back.out(3)', duration: 0.6, scrollTrigger: { trigger: el.querySelector('.plc__table'), start: 'top 75%' } });
  };
})();
